var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestosHumanosIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.093 17.9975C13.0149 17.9975 8.18288 24.6875 8.14382 24.6875C8.10476 24.6875 3.3118 21.3146 3.29283 21.2728C3.27385 21.2309 8.12485 14.2591 8.12485 14.1642C8.12485 14.0415 0.893552 11.7091 0.447175 11.5362C0.374639 11.5083 2.1992 5.85603 2.21594 5.83929C2.24942 5.80023 10.273 8.46175 10.3344 8.46175C10.3567 8.46175 10.3846 8.42827 10.3902 8.38922C10.4125 8.27762 10.446 0.0977727 10.4851 0.0419756C10.5297 -0.0249808 16.3159 0.00291774 16.3493 0.0252366C16.433 0.0810336 16.5446 8.73516 16.6897 8.73516C16.7678 8.73516 24.4288 6.1127 24.4622 6.15175C24.5069 6.20197 26.2422 11.8542 26.2198 11.8765C26.1696 11.9267 18.3971 14.5046 18.3748 14.5994C18.358 14.6775 22.9948 21.4122 22.978 21.4569C22.9613 21.5015 18.2074 25 18.1627 25C18.1069 24.9888 13.1968 17.9975 13.0908 17.9975H13.093Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestosHumanosIcon);
export default __webpack_public_path__ + "static/media/restos_humanos_icon.655ba78e3457d553168ffffa07132405.svg";
export { ForwardRef as ReactComponent };